__webpack_require__.p = "/ghibli-songs-player/";